import { useEffect } from 'react';
import { useParams, useMatch } from 'react-router-dom';
import {
  ERROR_ROUTE,
  SURVEY_EXPIRED_ROUTE,
  SURVEY_ROUTE,
  SURVEY_THANKYOU_ROUTE,
  SURVEY_RESULT_ROUTE,
} from '../constants/routes';
import { useRouter } from './useRouter';
import { selectHasMetSurveyRequirements } from '../redux/selectors/survey_selectors';
import { useAppSelector } from '../redux/ReduxProvider';

export const useSurveyGuard = () => {
  const { survey_code: surveyCode = null } = useParams();
  const { goTo } = useRouter({ keepQueryParams: true });
  const match = useMatch(SURVEY_ROUTE);
  const canSubmitSurvey = useAppSelector(selectHasMetSurveyRequirements);

  const { error, isSubmitted, isExpired, canViewResults } = useAppSelector((state) => state.survey);

  useEffect(() => {
    if (error) {
      goTo(ERROR_ROUTE);
    } else if (isSubmitted) {
      goTo(canViewResults ? SURVEY_RESULT_ROUTE : SURVEY_THANKYOU_ROUTE, [surveyCode]);
    } else if (isExpired) {
      goTo(SURVEY_EXPIRED_ROUTE, [surveyCode]);
    } else if (!isSubmitted && !match && !canSubmitSurvey) {
      goTo(SURVEY_ROUTE, [surveyCode]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isSubmitted, isExpired, surveyCode, match?.pathname, canSubmitSurvey, canViewResults]);
};
